import React from "react";
import { useStyles } from "./style";
import { SocialProps } from "./types";

export const Social = (props: SocialProps) => {
  const classes = useStyles();

  return (
    <div className={classes.socialContainer}>
      <div className={classes.title}>{props.title}</div>
      <div className={classes.socialItems}>
        {props.elements.map((el) => (
          <a href={el.href} key={el.href} target="_blank" className={classes.socialItem} aria-label="Social item">
            {el.img}
          </a>
        ))}
      </div>
    </div>
  );
};
